import styled from "styled-components";
import Responsable from "../../../Responsable";
import { media } from "../../../../constants/styles";

const Pluspot = () => {
  const srcRoot = '/image/webp/project/pluspot/content';
  return <>
    <Responsable
      pc={
        <ContentContainer>
          <img src={`${srcRoot}/pluspot-pc-1.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-pc-2.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-pc-3.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-pc-4.png`} width={'100%'} />
          <GridContainer>
            <GifContainer>
              <img src={`${srcRoot}/pluspot-pc-5-1.gif`} width={'56.5%'} />
            </GifContainer>
            <div className="img-margin-3">
              <img src={`${srcRoot}/pluspot-pc-5.png`} width={'100%'} />
            </div>
          </GridContainer>
          <img src={`${srcRoot}/pluspot-pc-6.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-pc-7.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-pc-8.png`} width={'100%'} />
        </ContentContainer>
      }

      tablet={
        <ContentContainer>
          <img src={`${srcRoot}/pluspot-tablet-1.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-tablet-2.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-tablet-3.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-tablet-4.png`} width={'100%'} />
          <GridContainer>
            <GifContainer>
              <img src={`${srcRoot}/pluspot-pc-5-1.gif`} width={'56.5%'} />
            </GifContainer>
            <div className="img-margin-3">
              <img src={`${srcRoot}/pluspot-pc-5.png`} width={'100%'} />
            </div>
          </GridContainer>
          <img src={`${srcRoot}/pluspot-tablet-6.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-tablet-7.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-tablet-8.png`} width={'100%'} />
        </ContentContainer>
      }

      mobile={
        <ContentContainer>
          <img src={`${srcRoot}/pluspot-mobile-1.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-mobile-2.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-mobile-3.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-mobile-4.png`} width={'100%'} />
          <GridContainer>
            <GifContainer>
              <img src={`${srcRoot}/pluspot-pc-5-1.gif`} width={'70%'} />
            </GifContainer>
            <div className="img-margin-3">
              <img src={`${srcRoot}/pluspot-pc-5.png`} width={'100%'} />
            </div>
          </GridContainer>
          <img src={`${srcRoot}/pluspot-mobile-6.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-mobile-7.png`} width={'100%'} />
          <img src={`${srcRoot}/pluspot-mobile-8.png`} width={'100%'} />
        </ContentContainer>
      }
    /></>;
};

export { Pluspot };

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;

  img {
    margin-bottom: -1px;
    object-fit: cover;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  
  .img-margin-3 {
    display: flex;
  }

  ${media.TABLET} {
    grid-template-columns: repeat(1, 1fr);

    & > div {
      aspect-ratio: 1 / 1;
    }
  }
  
  ${media.TABLET} {
    & > div {
      aspect-ratio: 375 / 447;
    }
  }
`;
const GifContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #905DF6;
`;